export default {
    controls: {
        undo: {
            title: 'Desfer',
        },
        redo: {
            title: 'Refer',
        },
        bold: {
            title: 'Negreta',
        },
        italic: {
            title: 'Cursiva',
        },
        underline: {
            title: 'Subratllat',
        },
        strikethrough: {
            title: 'Ratllat',
        },
        code: {
            title: 'Codi',
        },
        fontColor: {
            title: 'Color de font',
            labels: {
                noColor: 'Sense color',
            },
        },
        fontBackgroundColor: {
            title: 'Color de resaltat del text',
            labels: {
                noColor: 'Sense color',
            },
        },
        linkAdd: {
            title: 'Afegir enllaç',
            labels: {
                link: 'Enllaç',
            },
            actions: {
                add: 'Afegir',
                cancel: 'Cancel·lar',
            },
        },
        linkRemove: {
            title: 'Eliminar enllaç',
        },
        image: {
            title: 'Afegir imatge',
            actions: {
                upload: 'Pujar imatge',
                url: 'Des de URL',
                add: 'Afegir',
                cancel: 'Cancel·lar',
                alignLeft: "Alinear a l'esquerra",
                alignCenter: 'Centrar',
                alignRight: 'Alinear a la dreta',
                remove: 'Eliminar imatge',
                resize: 'Redimensionar',
            },
            labels: {
                dropImageHere: 'Arrossega una imatge aquí o fes click per a pujar una',
                width: 'Ample',
                height: 'Alt',
                url: 'URL',
                insertOptions: 'Opcions de afegir imatge',
                editOptions: "Opcions d'imatge",
            },
            errorMessages: {
                notValidImage: 'La imatge no és vàlida',
            },
        },
        blockType: {
            title: 'Format de bloc',
            labels: {
                normal: 'Normal',
                header1: 'Títol 1',
                header2: 'Títol 2',
                header3: 'Títol 3',
                header4: 'Títol 4',
                header5: 'Títol 5',
                header6: 'Títol 6',
            },
        },
        fontSize: {
            title: 'Grandària de font',
            labels: {
                default: 'Per defecte',
            },
        },
        fontFamily: {
            title: 'Font',
            labels: {
                default: 'Per defecte',
            },
        },
        textAlign: {
            title: 'Alinear text',
            actions: {
                alignLeft: 'Esquerra',
                alignCenter: 'Centre',
                alignRight: 'Dreta',
                justify: 'Justificar',
            },
        },
        unorderedList: {
            title: 'Vinyetes',
        },
        orderedList: {
            title: 'Numeració',
        },
    },
};
